import React from 'react';
import './CenteredContainer.scss';
import CenteredContainerProps from '../../../types/CenteredContainerProps.types';

export const CenteredContainer: React.FC<CenteredContainerProps> = ({ children }) => {
  return (
    <div className="centered-container">
      <div style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <h1 className="centered-header">Marginal Weather Dispatcher Notes</h1>
        <hr className="centered-divider" />
      </div>
      {children}
    </div>
  );
};